import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';

import { delayGuard, tokenGuard } from '@careconne/core/guard';

const routes: Routes = [
  { path: '', redirectTo: 'download', pathMatch: 'full' },
  // {
  //   path: '',
  //   loadChildren: () => import('@careconne/pages/pages.module').then((m) => m.PagesModule),
  // },
  // {
  //   path: 'login',
  //   loadChildren: () => import('@careconne/pages/login/login.module').then((m) => m.LoginModule),
  //   canActivate: [tokenGuard],
  // },
  {
    path: 'download',
    loadChildren: () =>
      import('@careconne/pages/download-screen/download-screen.module').then((m) => m.DownloadScreenModule),
    canActivate: [tokenGuard],
  },
  {
    path: '403',
    loadChildren: () => import('@careconne/pages/forbidden/forbidden.module').then((m) => m.ForbiddenModule),
  },
  {
    path: '404',
    loadChildren: () => import('@careconne/pages/not-found/not-found.module').then((m) => m.NotFoundModule),
  },
  {
    path: 'record-list/:filename',
    loadChildren: () => import('@careconne/pages/record-list/record-list.module').then((m) => m.RecordListModule),
    canActivate: [delayGuard],
  },
  {
    path: 'answer',
    loadChildren: () => import('@careconne/pages/answer/answer.module').then((m) => m.AnswerModule),
    canActivate: [delayGuard],
  },
  {
    path: 'electronic-consent',
    loadChildren: () =>
      import('@careconne/pages/electronic-consent/electronic-consent.module').then((m) => m.ElectronicConsentModule),
    canActivate: [delayGuard],
  },
  {
    path: 'record-graph',
    loadChildren: () => import('@careconne/pages/record-graph/record-graph.module').then((m) => m.RecordGraphModule),
    canActivate: [delayGuard],
  },
  {
    path: 'view-record-list',
    loadChildren: () =>
      import('@careconne/pages/view-record-list/view-record-list.module').then((m) => m.ViewRecordListModule),
    canActivate: [delayGuard],
  },
  {
    path: '**',
    loadChildren: () => import('@careconne/pages/not-found/not-found.module').then((m) => m.NotFoundModule),
  },
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule],
})
export class AppRoutingModule {}
